(function(){
  var root = document.querySelector('.o-sk-v2-root');
  if (!root) return;
  root.classList.add('js-sk');
  function qsa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function qs(sel){ return root.querySelector(sel); }


  // Horizontal frames rail — edge fades only (no arrow chrome)
  (function(){
    var rail = qs('.frames-rail');
    if (!rail) return;
    var grid = rail.querySelector('.frame-grid');
    if (!grid) return;
    function updateFades(){
      var max = grid.scrollWidth - grid.clientWidth;
      var sl = grid.scrollLeft;
      // tiny epsilon for subpixel
      rail.classList.toggle('can-scroll-start', sl > 2);
      rail.classList.toggle('can-scroll-end', max > 4 && sl < max - 2);
    }
    grid.addEventListener('scroll', updateFades, { passive: true });
    window.addEventListener('resize', updateFades);
    if (window.ResizeObserver) {
      try { new ResizeObserver(updateFades).observe(grid); } catch (e) {}
    }
    // after images load layout may change
    grid.querySelectorAll('img').forEach(function(img){
      if (!img.complete) img.addEventListener('load', updateFades, { once: true });
    });
    updateFades();
    requestAnimationFrame(updateFades);
  })();

  qsa('.frame-gallery').forEach(function(g){
    var track = g.querySelector('.gallery-track');
    var dots  = g.querySelectorAll('.gallery-dots span');
    var prev  = g.querySelector('.gallery-prev');
    var next  = g.querySelector('.gallery-next');
    var idx   = 0;
    var len   = track.children.length;
    function go(i){
      idx = (i + len) % len;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function(d, di){ d.classList.toggle('active', di === idx); });
    }
    prev.addEventListener('click', function(e){ e.preventDefault(); go(idx - 1); });
    next.addEventListener('click', function(e){ e.preventDefault(); go(idx + 1); });
    dots.forEach(function(d, di){ d.addEventListener('click', function(e){ e.preventDefault(); go(di); }); });
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    qsa('[data-reveal]').forEach(function(el){ el.classList.add('in'); });
    return;
  }

  qsa('[data-reveal="group"]').forEach(function(g){
    Array.prototype.forEach.call(g.children, function(c, i){ c.style.setProperty('--i', i); });
  });

  function countUp(el){
    var text = el.textContent;
    var m = text.match(/^([\d,.]+)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[1].replace(/,/g, ''));
    var suffix = m[2];
    var dur = 900;
    var start = null;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString('en-US') + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (!en.isIntersecting) return;
      en.target.classList.add('in');
      io.unobserve(en.target);
      if (en.target.hasAttribute('data-count')) {
        en.target.querySelectorAll('.stat-num').forEach(countUp);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -4% 0px' });

  qsa('[data-reveal]').forEach(function(el){ io.observe(el); });

})();
